import { PageRoot } from 'commonStyled'
import styled from 'styled-components'

export const ExamInfoDetail = styled(PageRoot)`
  width: 100%;
  .editor {
    min-height: 150px;
    padding-left: 10px;
  }
  -webkit-user-select: auto;
  -ms-user-select: auto; /* IE 10 and IE 11 */
  user-select: auto; /* Standard syntax */
`
